export default "__VITE_ASSET__eba6ylKr__"